(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
     
  document.addEventListener("DOMContentLoaded", function () {
  const backTopButton = document.getElementById("back-top-button");
  let lastScrollY = window.scrollY;
  let hideTimeout;

  // 初始状态
  backTopButton.style.display = "none";
  backTopButton.style.opacity = "0";
  backTopButton.style.transition = "opacity 0.5s";

  if (window.scrollY > 500) {
    showButton();
  }

  function showButton() {
    backTopButton.style.display = "flex";
    requestAnimationFrame(() => {
      backTopButton.style.opacity = "1";
    });
  }

  function hideButton() {
    backTopButton.style.opacity = "0";
    setTimeout(() => {
      if (backTopButton.style.opacity === "0") {
        backTopButton.style.display = "none";
      }
    }, 500); // 与 transition 时间一致
  }

  window.addEventListener("scroll", function () {
    const currentScrollY = window.scrollY;

    // 滚动高度到500以上才显示
    if (currentScrollY <= 500) {
      hideButton();
    } else {
      showButton();
    }


    // 向上滚动 & 离顶部距离超过 100 时显示按钮
    // if (currentScrollY < lastScrollY && currentScrollY > 100) {
    //   showButton();
    // }

    // 向下滚动时立即隐藏按钮
    // if (currentScrollY > lastScrollY) {
    //   hideButton();
    // }
    lastScrollY = currentScrollY;
  });

  // 点击滚动到顶部
  backTopButton.addEventListener("click", function () {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // 监听custom-select值得变化，更新路由
    document.addEventListener('change', function (e) {
      if (e.target.matches('#SortBy') || e.target.matches('#SortByMobile')) {
        const selectedValue = e.target.value;
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', selectedValue);
        window.location.href = url.toString();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline-carousel"] && !window.DesignMode) return;
  try {
    
  

window.addEventListener('DOMContentLoaded', function () {
  
  const slides = document.querySelectorAll('.year-swiper .swiper-slide');
  const initial = slides.length - 4; // 倒数第4个
  const last = slides.length -1;
  
  const yearSwiper = new Swiper('.year-swiper', {
    direction: 'horizontal',
    slidesPerView: 5,
    spaceBetween: 32,
    initialSlide: last,
    speed: 1000,
    breakpoints: { 
      // 当窗口宽度 >= 375px
      375: {
        slidesPerView: 6,
        spaceBetween: 50
      },
      950: {
        slidesPerView: 7,
        spaceBetween: 0,
      },
      1440: {
        slidesPerView: 9,
        spaceBetween: 120
      },
    }
  });


  // 点击移动到对应slide
  document.querySelectorAll('.year-swiper .swiper-slide').forEach((slide, index) => {
    slide.addEventListener('click', () => {
      yearSwiper.slideTo(index);
    });
  });

  const swiper = new Swiper('.swiper', {
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 24,
      thumbs: {
        swiper: yearSwiper,
      },
      initialSlide: last,
      navigation: {
        prevEl: ".swiper-button-prev",
        nextEl: ".swiper-button-next",
      },
      effect : 'fade',
      fadeEffect: {
        crossFade: true,
      },
      speed: 1000,
      on: {
      init: function () {
        this.slideTo(initial);
      },
    }
   });
  });


  } catch(e) { console.error(e); }
})();
})();
